import { CSSObject } from '@emotion/react'
import { emptyCategoryPill } from './MomentStack/styles'

export const parentContainer: CSSObject = {
  overflow: 'auto',
  width: '100%',
  height: '100%',
}

export const spanWrapper: CSSObject = {
  display: 'flex',
  flexDirection: 'column',
  paddingBlock: 2,
  paddingInline: 4,
  minWidth: 0,
}

export const spanEmptyPill: CSSObject = {
  ...emptyCategoryPill,
  alignSelf: 'center',
  justifySelf: 'center',
}
